import * as i18n from 'i18next';
import { reactI18nextModule } from 'react-i18next';
import { en } from './translations.en';
import { fr } from './translations.fr';
import { de } from './translations.de';
import { nl } from './translations.nl';
import { es } from './translations.es';

const initOptions: i18n.InitOptions = {
  fallbackLng: 'en',
  debug: true,
​
  interpolation: {
    escapeValue: false // not needed for react!!
  },

  ns: ['translation'],

  defaultNS: 'translation',
  fallbackNS: 'translation',

  resources: {
    en: {
      translation: en
    },
    fr: {
      translation: fr
    },
    de: {
      translation: de
    },
    nl: {
      translation: nl
    },
    es: {
      translation: es
    }
  },
​
  // react i18next special options (optional)
  react: {
    wait: true,
    nsMode: 'default'
  }
};

const instance = i18n
  .use(reactI18nextModule)
  .init(initOptions);
​
export default instance;


// WEBPACK FOOTER //
// ./src/translations/i18n.ts